export const Tipos = {
  1: {
    name: 'Documentação de Veículos',
    color: '#23B7E5'
  },
  2: {
    name: 'Leilão de materiais',
    color: '#7266BA'
  },
  3: {
    name: 'Leilão de veículos',
    color: '#FAD733'
  },
  4: {
    name: 'Leilão de imóveis',
    color: '#27C24C'
  },
  5: {
    name: 'Sugestões para o site',
    color: '#C2B3A7'
  },
  6: {
    name: 'Sugestões para empresa',
    color: '#C2413D'
  },
  99: {
    name: 'Outros',
    color: '#003AC2'
  }
}



// WEBPACK FOOTER //
// ./src/app/website/contatos/components/Tipos.js